import './Navbar.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

function Navbar({ nombre, rol }) {
  const navigate = useNavigate();
  const [menuAbierto, setMenuAbierto] = useState(false);
  const menuRef = useRef();

  const handleLogout = () => {
    localStorage.removeItem('usuario');
    navigate('/');
  };

  const toggleMenu = () => setMenuAbierto(!menuAbierto);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuAbierto(false);
      }
    };

    if (menuAbierto) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuAbierto]);

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <img src="/logo.png" alt="Logo" className="logo" />
        <span className="title">IAPATAGONIA <span className="tech">TECHNOLOGY</span></span>
        <button className="hamburger" onClick={toggleMenu}>
          {menuAbierto ? <FaTimes size={24} color="white" /> : <FaBars size={24} color="white" />}
        </button>
      </div>

      <div className={`navbar-links ${menuAbierto ? 'activo' : ''}`} ref={menuRef}>
        <NavLink to="/panel" className="navlink" onClick={() => setMenuAbierto(false)}>Panel</NavLink>
        <NavLink to="/sensores" className="navlink" onClick={() => setMenuAbierto(false)}>Sensores</NavLink>
        <NavLink to="/tiempo-real" className="navlink" onClick={() => setMenuAbierto(false)}>Tiempo Real</NavLink>
        <NavLink to="/lecturas-historicas" className="navlink" onClick={() => setMenuAbierto(false)}>Lecturas Históricas</NavLink>  
        <NavLink to="/historial" className="navlink" onClick={() => setMenuAbierto(false)}>Historial</NavLink>
        <NavLink to="/alarmas" className="navlink" onClick={() => setMenuAbierto(false)}>Alarmas</NavLink>
        <NavLink to="/configuraciones" className="navlink" onClick={() => setMenuAbierto(false)}>Configuraciones</NavLink>
      </div>

      <div className="navbar-right desktop-only">
        <span>{nombre} ({rol})</span>
        <button className="logout-btn" onClick={handleLogout}>Cerrar sesión</button>
      </div>
    </nav>
  );
}

export default Navbar;
  